import { render, staticRenderFns } from "./EditPageDocument.vue?vue&type=template&id=5b1cee02"
import script from "./EditPageDocument.vue?vue&type=script&lang=js"
export * from "./EditPageDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports